module.exports = __webpack_public_path__ + "img/jh.a0e20c8.png";